import { ListItemButton, ListItemText } from "@mui/material";
import LazyImage from "components/LazyImage";
import { CategoryItem } from "modules/category/types";
import React, { FC, useMemo } from "react";
import CheckIcon from "@mui/icons-material/Check";
import { colors } from "common";

interface Props {
  i: CategoryItem;
  categVal: string[];
  onClick: () => void;
}

export const CategListItem: FC<Props> = ({ i, onClick, categVal }) => {
  const isChecked = useMemo(() => {
    return categVal.includes(i.name);
  }, [categVal, i]);

  return (
    <ListItemButton onClick={onClick}>
      <LazyImage src={i?.icon_sidedrawer ?? ""} width={20} height={20} />
      <ListItemText
        sx={{
          color: isChecked ? colors.error : "initial",
          opacity: 0.8,
          ml: "1em",
        }}
      >
        {i.name}
      </ListItemText>
      {isChecked && <CheckIcon sx={{ color: colors.error }} />}
    </ListItemButton>
  );
};
